<template xmlns:template="http://www.w3.org/1999/html">
		<div>
				<v-card elevation="1" class="pa-auto">

						<form-filter-drawer
								:folks="folks"
								@checkperson="checkperson" @selectLocalBox="selectDocuments"
								@closeSidebar="toggleDataSidebar" v-if="addNewDataSidebar"
								:isSidebarActive="addNewDataSidebar">
						</form-filter-drawer>
						<v-layout v-resize="onResize" column>
								<v-row dense>
										<v-col cols="12">
												<v-data-table
														v-model="selected"
														:headers="headers"
														:items="rows"
														dense
														id="mytable"
														show-select
														item-key="id"
														:disabled="false"
														:search="search"
														@click:row="clicklineRead"

														mobile-breakpoint="960"
														:loading="loading"
														:header-props="headerProps"
														class="elevation-3 table-cursor"
														:item-class="row_classes"
														hide-default-footer
														no-data-text="Nenhum registro disponível"
														no-results-text="Nenhum registro encontrado"
												>


														<template v-slot:header.data-table-select>
																<v-checkbox
																		hide-details
																		v-model="selectCheck"
																		@click="selectCheckMothd"
																		:indeterminate="indeterminate"
																		class=" mt-0 mr-0"
																>
																		<template v-slot:label>
																				<v-menu bottom right offset-y origin="top left" transition="scale-transition">
																						<template v-slot:activator="{ on }">

																								<v-btn class="ml-0 pl-0" x-small dark icon v-on="on">
																										<v-tooltip bottom>
																												<template v-slot:activator="{ on }">
																														<v-icon class="ml-0 " dense v-on="on" color="black">
																																mdi-menu-down
																														</v-icon>
																												</template>
																												<span>Selecionar</span>
																										</v-tooltip>
																								</v-btn>
																						</template>
																						<v-card>
																								<v-list>
																										<v-list-item
																												v-for="(item, index) in items"
																												:key="index"
																												@click="getSelectItem(item)"
																										>
																												<v-list-item-title>{{ item.title }}</v-list-item-title>
																										</v-list-item>
																								</v-list>
																						</v-card>
																				</v-menu>
																		</template>
																</v-checkbox>

														</template>
														<template v-slot:header.label="{header}">
																<div style="display: inline-block;">{{ header.text }}</div>
																<v-menu :close-on-content-click="false" :nudge-width="200" offset-y transition="slide-y-transition" left
																        fixed style="position: absolute; right: 0">
																		<template v-slot:activator="{ on, attrs }">
																				<v-btn color="indigo" icon v-bind="attrs" v-on="on">
																						<v-icon small>
																								mdi-filter-variant
																						</v-icon>
																				</v-btn>
																		</template>
																		<v-list flat dense class="pa-0">

																				<v-list-item-group multiple v-model="selectedNodeIds">
																						<template v-for="(item, i) in getLabels">

																								<v-list-item :key="`item-${i}`" :value="item">
																										<template v-slot:default="{ active,toggle }">
																												<v-list-item-action>
																														<v-checkbox :input-value="active" :true-value="item.id" @click="toggle" color="primary"
																														            dense></v-checkbox>
																												</v-list-item-action>
																												<v-list-item-content>
																														<v-list-item-title>
																																<v-chip
																																		class="mr-1"
																																		:color="item.color"
																																		text-color="white"
																																		small
																																>
																																		{{item.name}}
																																</v-chip>
																														</v-list-item-title>
																												</v-list-item-content>
																										</template>
																								</v-list-item>
																						</template>
																				</v-list-item-group>
																				<v-divider></v-divider>
																				<!--									<v-btn text block @click="toggleAll(header.value)">Toggle all</v-btn>-->
																				<!--									<v-btn text block @click="clearAll(header.value)">Clear all</v-btn>-->
																		</v-list>
																</v-menu>
														</template>
														<template v-slot:top="{ pagination, options, updateOptions }">
																<v-data-footer
																		:pagination="pagination"
																		:options="options"
																		@update:options="updateOptions"
																		items-per-page-text="$vuetify.dataTable.itemsPerPageText"/>

																<v-card v-if="!$vuetify.breakpoint.xsOnly && !$vuetify.breakpoint.smOnly" elevation="0">

																		<v-row no-gutters align="end">
																				<!--             fim   lista de selecao e checkbox-->
																				<!--                    selecao inbox-->
																				<v-col md="6" lg="3">
																						<v-row no-gutters align="center">
																								<v-col md="2" lg="2">
																										<v-menu bottom right offset-y origin="top left" transition="scale-transition">
																												<template v-slot:activator="{ on }">
																														<v-row no-gutters justify="center">
																																<v-btn small :disabled="actionItemsDisable" icon v-on="on">
																																		<v-tooltip bottom>
																																				<template v-slot:activator="{ on }">
																																						<v-icon v-on="on" color="primary">mdi-file-edit-outline</v-icon>
																																				</template>
																																				<span>Ações</span>
																																		</v-tooltip>
																																</v-btn>
																														</v-row>
																												</template>
																												<v-card>
																														<v-list>
																																<v-list-item
																																		v-for="(item, index) in actionItems"
																																		:key="index"
																																		@click="getSelectActionItem(item)"
																																>
																																		<v-list-item-title>{{ item.action }}</v-list-item-title>
																																		<v-list-item-icon>
																																				<v-icon>{{ item.icon }}</v-icon>
																																		</v-list-item-icon>
																																</v-list-item>
																														</v-list>
																												</v-card>
																										</v-menu>
																								</v-col>
																								<v-col md="9" lg="9">
																										<v-row no-gutters justify="start">
																												<v-select
																														dense
																														full-width
																														hide-details
																														:disabled="disabled"
																														outlined
																														v-model="inboxModel"
																														:style="{color:itemColorSelect} "
																														item-color="Albescent"
																														:items="itemsBox"
																														item-text="name"
																														:color="itemColorSelect"
																														ref="selectItemBoxForder"
																														return-object
																														@change="selectDocuments"
																												>
																														<template v-slot:label>
																																<span :style="{ color: itemColorSelect ,}">Inbox</span>
																														</template>
																														<template slot="item" slot-scope="data">
																																<!-- HTML that describe how select should render selected items -->
																																<span class="text-lg-caption"
																																      :style="{ color: data.item.color ,}">{{ data.item.name }}</span>
																														</template>
																														<template slot="selection" slot-scope="data">
																																<!-- HTML that describe how select should render selected items -->
																																<span :class="itemColorSelect">{{ data.item.name }}</span>
																														</template>
																												</v-select>
																										</v-row>
																								</v-col>
																						</v-row>
																				</v-col>
																				<v-col md="6" lg="2">
																						<v-row no-gutters>
																								<v-col cols="11">
																										<v-select
																												dense
																												hide-details
																												outlined
																												color="green accent-4"
																												:disabled="diableTypeItem"
																												:items="itemsType"
																												item-text="name"
																												placeholder="Documentos"
																												@change="selectDocuments"
																										>
																										</v-select>
																								</v-col>
																						</v-row>
																				</v-col>
																				<v-col v-if="$vuetify.breakpoint.mdOnly" md="6" lg="3">

																						<v-row no-gutters align="center" justify="center">
																								<v-col class="text-center" cols="4">
																										<v-checkbox
																												:disabled="disabled"
																												hide-details
																												v-model="folks"
																												:input-value="folks"
																												open-on-clear
																												dense
																												label="Pessoal"
																												class="mt-0 ml-md-5"
																										>

																										</v-checkbox>
																								</v-col>
																								<v-col class="text-center" cols="3">
																										<v-btn large class="ml-2" icon to="document-calendar">
																												<v-icon class="">
																														mdi-calendar-range
																												</v-icon>
																										</v-btn>
																								</v-col>
																								<v-col class="text-center" cols="5">
																										<v-btn
																												width="130"
																												color="primary"
																												dark
																												to="DocumentRegister"
																										><span class="text-md-subtitle-2">Novo</span></v-btn>
																								</v-col>

																						</v-row>
																				</v-col>
																				<v-col md="6" lg="3">
																						<v-row no-gutters justify="start">
																								<v-col cols="12" md="11">
																										<v-text-field
																												outlined
																												:disabled="disabled"
																												@input="searchItems"
																												dense
																												hide-details
																												append-icon="mdi-magnify"
																												label="Busca"
																												v-model="search"
																										></v-text-field>
																								</v-col>
																						</v-row>
																				</v-col>
																				<v-col v-if="!$vuetify.breakpoint.mdOnly" md="6" lg="4">

																						<v-row no-gutters>
																								<v-col cols="3">
																										<v-row align="end" no-gutters>
																												<v-checkbox
																														:disabled="disabled"
																														hide-details
																														v-model="folks"
																														:input-value="folks"
																														open-on-clear
																														dense
																														label="Pessoal"
																														class="mt-0"
																												>

																												</v-checkbox>
																										</v-row>
																								</v-col>
																								<v-col cols="2">
																										<v-row justify="center" no-gutters>
																												<v-btn icon to="document-calendar">
																														<v-icon>
																																mdi-calendar-range
																														</v-icon>
																												</v-btn>
																										</v-row>
																								</v-col>
																								<v-col cols="2">
																										<v-row justify="center" no-gutters>
																												<v-btn @click="btnfaStartDocument = !btnfaStartDocument" icon>
																														<v-icon :color="btnfaStartDocument ? 'primary' : ''">
																																fa-star
																														</v-icon>
																												</v-btn>
																										</v-row>
																								</v-col>
																								<v-col class=" text-center  " cols="4">
																										<v-row no-gutters>
																												<v-btn
																														width="100%"
																														color="primary"
																														dark
																														to="DocumentRegister"
																												><span class="text-md-subtitle-2">Novo</span></v-btn>
																										</v-row>
																								</v-col>

																						</v-row>
																				</v-col>
																		</v-row>
																</v-card>
																<div v-else>
																		<v-speed-dial
																				bottom
																				absolute
																				color="pink"
																				fixed
																				v-model="fab"
																				right
																		>
																				<template v-slot:activator>
																						<v-btn
																								color="blue darken-2"
																								dark
																								fab
																						>
																								<v-icon v-if="fab">
																										mdi-plus
																								</v-icon>
																								<v-icon v-else>
																										mdi-filter-variant
																								</v-icon>
																						</v-btn>
																				</template>
																				<v-btn
																						fab
																						dark
																						small
																						color="green"
																						to="document-calendar"
																				>
																						<v-icon>mdi-calendar-range</v-icon>
																				</v-btn>
																				<v-btn
																						fab
																						dark
																						small
																						color="indigo"
																						@click.stop="addNewData"
																				>
																						<v-icon>mdi-filter-variant</v-icon>
																				</v-btn>
																		</v-speed-dial>
																</div>

																<v-toolbar v-if="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly" flat color="white">
																		<v-col cols="1">
																				<v-row justify="start" no-gutters>
																						<v-btn @click="btnfaStartDocument = !btnfaStartDocument" icon>
																								<v-icon :color="btnfaStartDocument ? 'primary' : ''">
																										fa-star
																								</v-icon>
																						</v-btn>
																				</v-row>
																		</v-col>
																		<v-col cols="9">
																				<v-text-field
																						class="mr-3"
																						outlined
																						dense
																						v-model="search"
																						append-icon="mdi-magnify"
																						label="Busca"
																						single-line
																						full-width
																						hide-details
																				></v-text-field>
																		</v-col>
																		<v-btn
																				color="primary"
																				dark
																				to="DocumentRegister"
																		><span class="text-md-subtitle-2">Novo</span></v-btn>
																		<v-menu bottom right offset-y origin="top left" transition="scale-transition">
																				<template v-slot:activator="{ on }">
																						<v-btn x-large :disabled="actionItemsDisable" icon v-on="on">
																								<v-icon color="primary">mdi-file-edit-outline</v-icon>
																						</v-btn>
																				</template>
																				<v-card>
																						<v-list>
																								<v-list-item
																										v-for="(item, index) in actionItems"
																										:key="index"
																										@click="getSelectActionItem(item)"
																								>
																										<v-list-item-title>{{ item.action }}</v-list-item-title>
																										<v-list-item-icon>
																												<v-icon>{{ item.icon }}</v-icon>
																										</v-list-item-icon>
																								</v-list-item>
																						</v-list>
																				</v-card>
																		</v-menu>
																</v-toolbar>
														</template>

														<template v-slot:item.number="{item}">
																<div class="text-left">
																		<span>{{item.number}} - {{item.type_doc}} </span>
																</div>
														</template>
														<template v-slot:item.from="{item}">
																<div class="text-left">
																		<span>{{item.from.initial}}</span>
																</div>
														</template>
														<template v-slot:item.to="{item}">
																<div class="text-left">
																		<span>{{item.to.initial}}</span>
																</div>
														</template>
														<template v-slot:item.topic="{item}">
																<div class="text-left">
																		<v-tooltip bottom>
																				<template v-slot:activator="{ on, attrs }">
								<span class="d-inline-block text-truncate"
								      style="max-width: 200px;"
								      v-bind="attrs"
								      v-on="on">{{item.topic}}</span>
																				</template>
																				<span>{{item.topic }}</span>
																		</v-tooltip>
																</div>
														</template>
														<template v-slot:item.label="{item}">
																<div v-for="(value,index) in item.label" :key="index" class="d-inline">
																		<v-chip
																				class="mr-1"
																				close
																				v-if="index < limitationList"
																				:color="value.color"
																				text-color="white"
																				close-icon="mdi-delete"
																				@click:close="deleteItemLabel(value.id,item)"
																				small
																		>
																				{{value.name}}
																		</v-chip>
																</div>
																<v-menu v-if="item.label.length > 2" open-on-hover bottom offset-x>
																		<template v-slot:activator="{ on, attrs }">
																				<v-btn v-on="on" v-bind="attrs" icon>
																						<v-icon v-text="`+${item.label.length > 2 ? (item.label.length - limitationList) : ''}  `"
																						        x-small>
																								mdi-plus
																						</v-icon>
																				</v-btn>
																		</template>
																		<v-list>
																				<v-list-item v-for="(value,index) in computedObj(item.label)" :key="index">
																						<v-chip @click:close="deleteItemLabel(value.id,item)" close close-icon="mdi-delete"
																						        text-color="white" small :color="value.color">
																								{{value.name}}
																						</v-chip>
																				</v-list-item>
																		</v-list>
																</v-menu>
																<div v-if="item.label.length == 0">
																		<span></span>
																</div>
														</template>
														<template v-slot:item.deadline="{item}">
																<div class="text-left">

																		<span :class="item.deadline || datePrazo(item.deadline) < 0  ? `black--text`:`red--text`">{{item.deadline | correctDate}}</span>

																</div>
														</template>
														<template v-slot:item.Received="{item}">
																<div class="text-left">
																		<span v-if="item.Received">{{item.Received | dateInstence}}</span>
																		<span v-else>Sem data</span>
																</div>
														</template>

												</v-data-table>
										</v-col>
								</v-row>
						</v-layout>

				</v-card>
		</div>
</template>

<script>
 import FormFilterDrawer from "./FormFilterDrawer";
 import {differenceInDays} from "date-fns"


 export default {
    name: "Documents",
    components: {
      FormFilterDrawer,
    },
    data: () => ({
      desserts: {},
      isMobile: false,
      rows: [],
      rowsAtual: [],
      disabled: true,
      setor: false,
      folks: false,
      selectCheck: false,
      search: '',
      fab: false,
      limitationList: 2,
      contLabel: null,
     selectedNodeIds: [],
     selectionLabelFilter:false,
      headerProps: {
        sortByText: "buscar por",
      },
     filters: { 'labels': []},
     activeFilters: {},
      addNewDataSidebar: false,
      singleSelect: false,
      inboxModel: {},
      selected: [],
      actionItems: [
        {id: 1, action: 'Arquivar', icon: 'mdi-archive-arrow-down'}
      ],
      actionItemsDisable: true,
      itemColorSelect: '',
      diableTypeItem: true,
      itemsType: [
        {title: 'Memorando'},
        {title: 'Ofício'},
      ],
	    btnfaStartDocument:false,
      items: [
        {id: 1, title: 'Todos'},
        {id: 2, title: 'Nenhum'},
        {id: 3, title: 'Lidas'},
        {id: 4, title: 'Não Lidas'},
        {id: 5, title: 'Sem Etiquetas'},
        {id: 6, title: 'Com Etiquetas'},
      ],
      loading: true,
      selectdocument: 'Memorando',
      headers: [
        {text: "Numero", align: "left", value: "number", sortable: true, class: 'sticky-header'},
        {text: "De", align: "left", value: "from", class: 'sticky-header'},
        {text: "Para", align: "left", value: "to", class: 'sticky-header'},
        {text: "Assunto", align: "left", value: "topic", class: 'sticky-header'},
        {text: "Etiqueta",
	        align: "left",
	        value: "label",
	        sortable: false,
	        class: 'sticky-header',
         },
        {text: "Prazo", align: "left", value: "deadline", sortable: false, class: 'sticky-header'},
        {text: "Recebido", align: "left", value: "Received", sortable: false, class: 'sticky-header'},
      ],
    }),

    apollo: {
      itemsBox: {
        query: require("@/graphql/queries/Documents.gql").getFolders,
        update: (data) => {
          return data.folders
        },
        fetchPolicy: "network-only",
        // result(data) {
	       //  if(data.data !== undefined){
        //   var id = data.data.folders.filter((e) => {
        //    return e.alias === "inbox"
        //   }).map((x) => x.id)[0]
        //   this.$apollo.query({
        //    query: require("@/graphql/queries/Documents.gql").getDocumentBoxFolder,
        //    variables: {
        //     id: id
        //    },
        //    fetchPolicy: "network-only",
        //   }).catch(({graphQLErrors}) => {
        //    console.error(graphQLErrors)
        //   }).then((data) => {
        //    let array = data.data.documentBoxes.map((e) => ({
        //     id: e.id,
        //     id_document: e.document.id,
        //     type_doc: e.document.document_type.name,
        //     number: e.document.number,
        //     from:this.$options.filters.entityFrom(e.document.receivers),
        //     fromName: e.entity.name,
        //     to: this.$options.filters.entityTo(e.document.receivers),
        //     topic: e.document.subject,
        //     label: e.labels,
        //     deadline: e.document.delivery_time,
        //     Received: e.created_at,
        //     read: e.read,
        //     private: e.document.private,
        //     star:e.is_starred
        //    }))
        //    this.loading = data.loading
        //    this.disabled = false
        //    this.rows = array
        //    this.rowsAtual = this.rows
        //   })
	       //  }
        // }
      },
	     getLabels:{
       query:require('../../graphql/queries/Label.gql').getLabels,
		     update:(data)=>{
			     return data.labels
		     }
	     }
    },
    computed: {
      indeterminate: function () {
        var value;
        if (this.selected.length > 0 && this.selected.length !== this.rows.length) {
          value = true
        } else if (this.selected.length == 0) {
          value = false
        }
        return value
      },
    },
    watch: {
     selectedNodeIds(val){
      console.log(val,'array do select')
	     const row = this.rows.filter((e)=>{
	      console.log(e,'array do de row')
		     return e
	     })
	     console.log(row)


     },
      inboxModel(val) {
        if(val !== undefined){
          this.$apollo.query({
            query: require("@/graphql/queries/Documents.gql").getDocumentBoxFolder,
            variables: {
              id: val.id
            },
            fetchPolicy: "network-only",
          }).catch(({graphQLErrors}) => {
            console.error(graphQLErrors)
          }).then((data) => {
            let array = data.data.documentBoxes.map((e) => ({
              id: e.id,
              id_document: e.document.id,
              type_doc: e.document.document_type.name,
              number: e.document.number,
              from:this.$options.filters.entityFrom(e.document.receivers),
              fromName: e.entity.name,
              to: this.$options.filters.entityTo(e.document.receivers),
              topic: e.document.subject,
              label: e.labels,
              deadline: e.document.delivery_time,
              Received: e.created_at,
              read: e.read,
              private: e.document.private,
              star:e.is_starred
            }))
            this.loading = data.loading
            this.disabled = false
            this.rows = array
            this.rowsAtual = this.rows
          })
        }


        this.setcolor(val.color)
        this.itemColorSelect = val.color
      },
      selected: function (val) {
        if (val.length > 0) {
          this.actionItemsDisable = false
          if (val.length === this.rows.length) {
            this.selectCheck = true
          }
        } else {
          this.actionItemsDisable = true
        }
      },

      itemsBox: function (val) {
        val.forEach((e) => {
          if (e.name == "Recebidos") {
            this.inboxModel = e
            this.setcolor(e.color)
          }
        })
      },
      folks: function (val) {
        if (val) {
          var row = this.rows.filter((e) => {
            return e.private === true
          })
          this.rows = row
        } else {
          this.rows = this.rowsAtual
        }
      },
     btnfaStartDocument: function (val) {
      if (val) {
       var row = this.rows.filter((e) => {
        return e.star === true
       })
       this.rows = row
      } else {
       this.rows = this.rowsAtual
      }
     }
    },
  methods: {
   onResize() {
    if (window.innerWidth < 769)
     this.isMobile = true;

    else
     this.isMobile = false;
   },
      checkperson(val) {
        this.folks = val
      },
      setcolor(color) {
        this.$refs.selectItemBoxForder.$el.getElementsByClassName('v-input__slot')[0].children[0].style.borderColor = color
      },
      clicklineRead(event, item) {

        this.$apollo.mutate({
          mutation: require("@/graphql/mutations/Documents.gql").updateDocumenRead,
          variables: {
            id: item.item.id
          }
        }).then(({data:{updateDocumentBox}}) => {
	        this.$apollo.mutate({
          mutation: require("@/graphql/mutations/Documents.gql").createDocumentView,
		        variables:{
           document:updateDocumentBox.document.id,
           user:this.$store.state.userID
		        }
	        }).then(()=>{
         }).catch(({graphQLErrors})=>{
	         console.log(graphQLErrors)
	        })
        }).catch(({graphQLErrors}) => {
          console.error(graphQLErrors)
        })

       this.$router.push({name: 'documentShow',params:{id:item.item.id_document},query:{id_box:item.item.id}}).catch((err) => {
        console.error(err)
       });



      },
      selectDocuments(val) {
        this.loading = true
        this.disabled = true
        this.selected = []
        this.selectCheck = false
        this.folks = false
        this.rows = []
		      console.log(val)
		      this.$apollo.query({
          query: require("@/graphql/queries/Documents.gql").getDocumentBoxFolder,
          variables: {
            id: val.id
          },
        }).catch((err) => {
          console.error(err)
        }).then((data) => {
          console.log(data)
          let array = data.data.documentBoxes.map((e) => ({
           id: e.id,
           id_document: e.document.id,
           type_doc: e.document.document_type.name,
           number: e.document.number,
           from:this.$options.filters.entityFrom(e.document.receivers),
           fromName: e.entity.name,
           to: this.$options.filters.entityTo(e.document.receivers),
           topic: e.document.subject,
           label: e.labels,
           deadline: e.document.delivery_time,
           Received: e.created_at,
           read: e.read,
           private: e.document.private,
           star:e.is_starred
          }))
          this.loading = data.loading
          this.disabled = false
          this.rows = array
          this.rowsAtual = this.rows
        })
      },
      row_classes(item) {
        let css = '';
        if (item.read === true) {
          css = 'grey lighten-4'
        } else {
          css = 'font-weight-bold'
        }
        return css

      },
      selectCheckMothd() {
        if (this.selectCheck) {
          this.selected = this.rows
        } else {
          this.selected = []
        }
      },

      searchItems(val) {
        this.search = val;
      },
      computedObj(item) {
        if (item.length > this.limitationList) {
          let itemLabel = item.slice(this.limitationList, item.length)
          return itemLabel
        }
      },
      datePrazo(item) {
        if (!item) return ''


        const startDate = new Date();
        const endDate = item;

        let diffInDays = differenceInDays(new Date(endDate), new Date(startDate));
        if (diffInDays < 0) return diffInDays * -1

        return diffInDays
      },
      getSelectActionItem(item) {
        this.loading = true
	       switch (item.action) {
          case "Arquivar":
           var itemBoxIdFolder = this.itemsBox.filter((e) => {
              return e.alias == "guarded"
            }).map((x) => x.id)[0]


            this.selected.forEach((value) => {
              let indexLine = this.rows.findIndex(x => x.id === value.id)
	            console.log(indexLine)
              this.rows.splice(indexLine, 1)
            })
            var arrayIds = this.selected.map((e) => {
              return e.id
            })

            this.$apollo.mutate({
              mutation: require("@/graphql/mutations/Documents.gql").UpdateFolderMutation,
              variables: {
                idBox: arrayIds,
                idFolder: itemBoxIdFolder
              }
            }).then(() => {
            }).catch((err) => {
              console.error(err)
            })
            this.selectCheck = false
            this.actionItemsDisable = true
            this.loading = false
            break;
        }

      },
      getSelectItem(item) {
        switch (item.id) {
          case 1:
            this.selectCheck = true
            this.selected = []
            this.selected = this.rows
            break;
          case 3:
            this.selected = []
            this.selected = this.rows.filter((e) => {
              return e.read === true
            })
            break;
          case 2:
            this.selectCheck = false
            this.selected = []
            break;
          case 4:
            this.selected = []
            this.selected = this.rows.filter((e) => {
              return e.read === false
            })
            break;
          case 5:
            this.selected = []
            this.selected = this.rows.filter((e) => {
              return e.label.length === 0
            })
            break;
          case 6:
            this.selected = []
            this.selected = this.rows.filter((e) => {
              return e.label.length !== 0
            })
            break;
        }
      },
      getIndex(item) {
        this.selectdocument = item.title
      },
      toggleDataSidebar(val = false) {
        this.addNewDataSidebar = val
      },
      addNewData() {
        this.toggleDataSidebar(true)
      },
      deleteItemLabel(item, obejct) {
        this.$apollo.mutate({
          mutation: require("@/graphql/mutations/Documents.gql").DeleteMutation,
          variables: {
            id: obejct.id,
            label: [item]
          }
        }).then(() => {
        })
        let index = obejct.label.findIndex(x => x.id === item)
        obejct.label.splice(index, 1)
      },
    },

 }
</script>

<style lang="css" scoped>
	.lineread {
		background-color: #909288;
	}

	.table-cursor tbody tr:hover {
		cursor: pointer !important;
	}

	.table-cursor > .v-data-table__wrapper > table > tbody > tr:hover {
		cursor: pointer;
	}

	::v-deep .v-data-table-header {
		background-color: #fff8f4;
	}

	::v-deep .v-data-table-header > tr {
		height: 1px;
	}


	::v-deep th {
		color: #000 !important;
	}

	::v-deep .v-data-table__wrapper > table > tbody > tr:hover {
		cursor: pointer;
	}
	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
		padding: 10px !important;
	}

	::v-deep .v-data-table > v-data-header > tr > th {
		padding: 0 1px !important;
	}


</style>
